/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavCrewSettings
 */
export interface InputUavCrewSettings {
    /**
     * 
     * @type {string}
     * @memberof InputUavCrewSettings
     */
    altitude?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUavCrewSettings
     */
    freqControl?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUavCrewSettings
     */
    freqVideo?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUavCrewSettings
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUavCrewSettings
     */
    pilot?: string;
    /**
     * RememberFlightParams — чи оновлювати ці налаштування параметрами кожної поданої заявки.
     * Вказівник, щоб відрізнити «не передали» від явного false: клієнти, які поля не шлють,
     * не мають мовчки вимикати поведінку, увімкнену за замовчуванням.
     * @type {boolean}
     * @memberof InputUavCrewSettings
     */
    rememberFlightParams?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InputUavCrewSettings
     */
    streamUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof InputUavCrewSettings
     */
    transmitterPlatformId?: number;
    /**
     * 
     * @type {number}
     * @memberof InputUavCrewSettings
     */
    uavPlatformId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InputUavCrewSettings
     */
    usesDroneId?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InputUavCrewSettings
     */
    workType?: InputUavCrewSettingsWorkTypeEnum;
}


/**
 * @export
 */
export const InputUavCrewSettingsWorkTypeEnum = {
    Reconnaissance: 'reconnaissance',
    Adjustment: 'adjustment',
    Bombing: 'bombing',
    Strike: 'strike',
    Retranslation: 'retranslation',
    Ew: 'ew'
} as const;
export type InputUavCrewSettingsWorkTypeEnum = typeof InputUavCrewSettingsWorkTypeEnum[keyof typeof InputUavCrewSettingsWorkTypeEnum];


/**
 * Check if a given object implements the InputUavCrewSettings interface.
 */
export function instanceOfInputUavCrewSettings(value: object): boolean {
    return true;
}

export function InputUavCrewSettingsFromJSON(json: any): InputUavCrewSettings {
    return InputUavCrewSettingsFromJSONTyped(json, false);
}

export function InputUavCrewSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavCrewSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'altitude': json['altitude'] == null ? undefined : json['altitude'],
        'freqControl': json['freqControl'] == null ? undefined : json['freqControl'],
        'freqVideo': json['freqVideo'] == null ? undefined : json['freqVideo'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'pilot': json['pilot'] == null ? undefined : json['pilot'],
        'rememberFlightParams': json['rememberFlightParams'] == null ? undefined : json['rememberFlightParams'],
        'streamUrl': json['streamUrl'] == null ? undefined : json['streamUrl'],
        'transmitterPlatformId': json['transmitterPlatformId'] == null ? undefined : json['transmitterPlatformId'],
        'uavPlatformId': json['uavPlatformId'] == null ? undefined : json['uavPlatformId'],
        'usesDroneId': json['usesDroneId'] == null ? undefined : json['usesDroneId'],
        'workType': json['workType'] == null ? undefined : json['workType'],
    };
}

export function InputUavCrewSettingsToJSON(value?: InputUavCrewSettings | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'altitude': value['altitude'],
        'freqControl': value['freqControl'],
        'freqVideo': value['freqVideo'],
        'phone': value['phone'],
        'pilot': value['pilot'],
        'rememberFlightParams': value['rememberFlightParams'],
        'streamUrl': value['streamUrl'],
        'transmitterPlatformId': value['transmitterPlatformId'],
        'uavPlatformId': value['uavPlatformId'],
        'usesDroneId': value['usesDroneId'],
        'workType': value['workType'],
    };
}

